import { FontSize } from '@frontend/atoms/appearanceAtom';

import httpClient from '../http';

export type UserPreferences = {
  user_email: string;
  font_size: FontSize;
};

export type UpdateUserPreferencesRequest = {
  font_size: FontSize;
};

export const userPreferencesService = {
  getUserPreferences: async (): Promise<UserPreferences> => {
    const response = await httpClient.get<UserPreferences>(`/backend/api/v1/user-preferences`);
    return response.data;
  },

  updateUserPreferences: async (prefs: UpdateUserPreferencesRequest): Promise<UserPreferences> => {
    const response = await httpClient.put<UserPreferences>(
      `/backend/api/v1/user-preferences`,
      prefs
    );
    return response.data;
  },
};
